export default "__VITE_ASSET__dx66HHsu__"